import { Globe } from "lucide-react";

function SourceButton({ label, count, isActive, onClick, testId }) {
  return (
    <button
      onClick={onClick}
      className={`text-left px-3 py-1.5 text-[10px] tracking-[0.15em] uppercase font-mono transition-colors duration-150 rounded-sm focus:outline-none ${
        isActive
          ? "bg-[#F2F2F2] dark:bg-zinc-900 font-semibold text-[#0A0A0A] dark:text-zinc-100"
          : "text-gray-500 dark:text-gray-400 hover:bg-[#F2F2F2] dark:hover:bg-zinc-900"
      }`}
      style={{ borderLeft: `2px solid ${isActive ? "#0A0A0A" : "transparent"}` }}
      data-testid={testId}
    >
      {label}
      <span className="ml-2 text-gray-400">{count}</span>
    </button>
  );
}

export function SourceFilter({ activeSource, stats, onSourceChange }) {
  const dynamicSources = Object.entries(stats.source_distribution || {})
    .sort((a, b) => b[1] - a[1])
    .map(([key, count]) => ({ key, label: key.toUpperCase(), count }));

  return (
    <div className="px-6 py-3 border-b border-[#E5E5E5] dark:border-zinc-800 flex-1 overflow-y-auto custom-scrollbar">
      <p className="text-xs tracking-[0.2em] uppercase font-mono text-gray-500 dark:text-gray-400 mb-2">
        <Globe className="w-3 h-3 inline mr-1" strokeWidth={1.5} />
        KILDER
      </p>
      <div className="flex flex-col gap-0.5">
        <SourceButton
          label="ALLE KILDER"
          count={stats.total_articles || 0}
          isActive={activeSource === "all"}
          onClick={() => onSourceChange("all")}
          testId="source-all"
        />
        {dynamicSources.map((opt) => (
          <SourceButton
            key={opt.key}
            label={opt.label}
            count={opt.count}
            isActive={activeSource === opt.key}
            onClick={() => onSourceChange(opt.key)}
            testId={`source-${opt.key}`}
          />
        ))}
      </div>
    </div>
  );
}
